<script setup>
import { truncate } from '@helpers/utils'
import moment from 'moment'
import Image from '@components/Image.vue'

const props = defineProps({
  post: {
    type: Object,
    required: true,
  },
  excerpt: {
    type: Boolean,
    default: true,
  },
  tags: {
    type: Boolean,
    default: false,
  },
})

const postCreatedAt = moment(props.post.visible_at)
</script>

<template>
  <a :href="`/learn/${post.slug}/`" class="post">
    <div>
      <Image
          :src="post.image"
          :alt="post.title"
          class="post__image"
          loading="lazy"
          v-if="post.image"
      />
    </div>
    <div class="post__content">
      <div class="post__time">{{ postCreatedAt.format('LL') }}</div>
      <div class="post__title">{{ post.title }}</div>
      <div class="post__excerpt" v-if="post.excerpt && excerpt">
        {{ truncate(post.excerpt, 50) }}
        <span class="post__more">Read More</span>
      </div>
      <div class="post__tags" v-if="post.tags?.length && tags">
        <span class="post__tag" v-for="tag in post.tags">{{ tag.name }}</span>
      </div>
    </div>
  </a>
</template>

<style lang="scss" scoped>
.post {
  text-decoration: none;

  .post__image {
    border-radius: 8px;
    width: 100%;
    margin-bottom: 16px;
    height: 180px;
    object-fit: cover;
  }

  .post__content {
    .post__time {
      color: var(--neutral-700, #767370);
      font-size: 12px;
      font-weight: 600;
      line-height: 20px; /* 166.667% */
      letter-spacing: 1.2px;
      text-transform: uppercase;
    }

    .post__title {
      color: var(--Neutral-1000, #3C3833);
      font-family: Outfit, 'Outfit Fallback', Arial, serif;
      font-size: 24px;
      font-weight: 600;
      line-height: 30px; /* 125% */
      margin: 8px 0;
    }

    .post__excerpt {
      color: var(--neutral-700, #767370);
      font-size: 14px;
      font-weight: 400;
      line-height: 24px; /* 171.429% */

      @media screen and (min-width: 768px) {
        font-size: 16px;
        line-height: 28px;
      }

      .post__more {
        color: var(--neutral-1000, #3C3833);
        font-weight: 600;
        text-decoration-line: underline;
      }
    }

    .post__tags {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;

      .post__tag {
        color: var(--Neutral-1000, #3C3833);
        text-align: center;
        font-family: Outfit, 'Outfit Fallback', Arial, serif;
        font-size: 12px;
        font-weight: 600;
        line-height: 20px; /* 166.667% */
        padding: 2px 20px;
        border-radius: 32px;
        background: var(--Neutral-100, #F1EFE8);
      }
    }
  }
}
</style>
